import { get } from '../../../../util/api'
import * as type from './type'


export const createShipmentRequest = () => ({
    type: type.CREATE_SHIPMENT_REQUEST,
    payload: {},
})

export const createShipmentSuccess = (shipment) => ({
    type: type.CREATE_SHIPMENT_SUCCESS,
    payload: {
        shipment,
    },
})

export const createShipmentError = (error) => ({
    type: type.CREATE_SHIPMENT_ERROR,
    payload: {
        error,
    },
})

export const createShipment = (salesOrderId, addShipment) => (dispatch, getState) => {
    if (!salesOrderId) {
        return
    }

    dispatch(createShipmentRequest())

    get('/api/shipment/create?salesOrderId=' + salesOrderId)
        .then(shipment => {
            addShipment(shipment)
            dispatch(createShipmentSuccess(shipment))
        })
        .catch(error => {
            dispatch(createShipmentError(error))
        })
}

export const getProviderUrl = (shipmentProvider) => (dispatch, getState) => {

    return get('/api/shipment/provider-url?provider=' + shipmentProvider)
        .then( response => {
            return response.url
        })
        .catch(error => {
            console.log(error)
        })
}

export const toggleShipmentTracking = (shipmentId) => ({
    type: type.TOGGLE_SHIPMENT_TRACKING,
    payload: {
        shipmentId,
    },
})



// WEBPACK FOOTER //
// ./src/modules/logistic/state/list/action.js